import { toId, toText } from '../../../common/package/list';

export function normalizeTeam(raw) {
    return {
        id: toId(raw?.id),
        name: toText(raw?.name, `Equipo ${raw?.id ?? ''}`.trim()),
        description: toText(raw?.description),
    };
}

// Members are shown with neutral labels; the draft never renders real names.
export function normalizeMember(raw) {
    return {
        id: toId(raw?.id ?? raw?.membership_id),
        userId: toId(raw?.user_id),
        label: toText(raw?.display, `Integrante ${raw?.user_id ?? ''}`.trim()),
        role: raw?.team_role ?? null,
    };
}

export function normalizeProjectTeam(raw) {
    return { id: toId(raw?.id), projectId: toId(raw?.project_id), teamId: toId(raw?.team_id) };
}
